import { FormikValues } from "formik";
import { api } from "../../axios";

export const createCustomPricingBump = async (
  form: FormikValues,
  token: string
) => {
  const response = await api.post(
    "/bx_block_survey/bump_pricings/create_custom_price_bump",
    {
      custom_price_bump: {
        bump_name: form.bumpName,
        bump_amount: form.bumpAmount,
        bump_type: form.bumpType,
        bump_for: form.bumpFor,
        bump_description: form.bumpDescription,
      }
    },
    {
      headers: { token: token },
    }
  );

  return response.data;
};
